import React from "react";
import { calcSessionMetrics } from "./constants";

// Per-week horizontal bar chart of session loads plus running totals for
// volume, tonnage and weekly AU. Rendered above the week's day cards.
export function WeeklyLoadBar({ days }) {
  const per = (days || []).map((d) => calcSessionMetrics(d.exercises, d.session_type));
  const total = per.reduce((a, m) => a + m.sessionLoad, 0);
  const totalVolume = per.reduce((a, m) => a + m.volume, 0);
  const totalTonnage = per.reduce((a, m) => a + m.tonnage, 0);
  const max = Math.max(...per.map((m) => m.sessionLoad), 1);
  return (
    <div className="border !border-yellow-400/40 !bg-yellow-400/[0.04] p-3 mb-3" data-testid="week-load-bar">
      <div className="flex items-center justify-between mb-2 flex-wrap gap-2">
        <div className="label-tiny !text-yellow-400">// WEEK LOAD</div>
        <div className="flex items-center gap-4 text-xs tabular-nums">
          <span><span className="text-text-secondary">Volume</span> <span className="font-heading">{totalVolume}</span></span>
          <span><span className="text-text-secondary">Tonnage</span> <span className="font-heading">{totalTonnage} kg</span></span>
          <span><span className="text-text-secondary">Weekly Load</span> <span className="font-heading !text-yellow-400">{total} AU</span></span>
        </div>
      </div>
      <div className="flex items-end gap-1 h-10">
        {per.map((m, i) => (
          <div key={i} className="flex-1 flex flex-col items-center gap-0.5">
            <div className="w-full !bg-yellow-400/60" style={{ height: `${(m.sessionLoad / max) * 100}%`, minHeight: "2px" }} title={`Day ${(days[i]?.day)}: ${m.sessionLoad} AU`} data-testid={`week-load-bar-day-${days[i]?.day}`} />
            <span className="text-[9px] text-text-secondary tabular-nums">{days[i]?.day}</span>
          </div>
        ))}
      </div>
    </div>
  );
}
